import {ValueObject} from '@s-ui/domain'

export class OfferPriceValueObject extends ValueObject {
  /**
   * @param {Number} spotPrice
   * @param {Number} financedPrice
   * @param {String} label
   * @param {String} legalConditions
   * @param {String} endDate
   * */
}
